const gains = [
  {
    number: "01",
    title: "Unshakeable Personal Clarity",
    body: "The quiet capacity to distinguish between external noise (what you should do) and your own foundational truth (what you must do).",
  },
  {
    number: "02",
    title: "Expanded Capacity",
    body: "A clearer sense of where your energy is going — and where it could go instead. That awareness alone creates space.",
  },
  {
    number: "03",
    title: "Aligned Action",
    body: "The confidence to execute your next move, knowing it is born of deep insight, not hasty reaction.",
  },
];

export default function WhatYoullGain() {
  return (
    <section id="gain" className="bg-cream py-28 md:py-36 scroll-mt-20">
      <div className="max-w-6xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-start">

          {/* Left — sticky label + intro */}
          <div className="lg:sticky lg:top-32 text-center lg:text-left">
            <p className="font-sans text-xs tracking-widest2 uppercase text-ink mb-6">
              What You&apos;ll Gain
            </p>
            <h2 className="font-serif text-4xl md:text-5xl font-light text-ink leading-snug mb-8">
              You won&apos;t leave<br />
              <em className="font-medium">the same way you came.</em>
            </h2>
            <p className="font-sans text-base font-light text-ink leading-relaxed mb-10 max-w-sm mx-auto lg:mx-0">
              This is a focused conversation with depth, direction, and movement; rooted in truth and self-trust.
            </p>
            <div className="w-full max-w-xs overflow-hidden mx-auto lg:mx-0">
              <img
                src="https://public.readdy.ai/ai/img_res/ad18511d3ccca1f0ab4a95e8f262f623.jpg"
                alt="Calm, intentional coaching session aesthetic"
                className="w-full h-48 object-cover object-top"
              />
            </div>
          </div>

          {/* Right — gains list */}
          <div className="flex flex-col divide-y divide-sand">
            {gains.map((gain) => (
              <div key={gain.number} className="py-8 flex gap-6 text-center lg:text-left justify-center lg:justify-start">
                <span className="font-serif text-xs text-ink mt-1 shrink-0 tracking-widest">{gain.number}</span>
                <div>
                  <h3 className="font-serif text-xl font-medium text-ink mb-2">{gain.title}</h3>
                  <p className="font-sans text-sm font-light text-ink leading-relaxed">{gain.body}</p>
                </div>
              </div>
            ))}
          </div>

        </div>
      </div>
    </section>
  );
}
